import { urls } from 'utils/urls';

import { buildApiRequest } from 'utils/api';

export function getSearchResultsRequest(query, addressTypes, setSourceAsGoogle) {
  return buildApiRequest('GET', urls.mapSearch, { text: query, addressTypes, setSourceAsGoogle: setSourceAsGoogle });
}

export function selectPlaceRequest(payload) {
  return buildApiRequest('POST', urls.placeSelect, payload);
}
